import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import "../tutorRegistration/TutorRegistration.css";
import {
  PROGRAM_CATEGORIES,
  ALL_COURSE_CATEGORIES,
} from "../../data/tutorPrograms";

const StepCredentials = ({
  formData,
  setFormData,
  errors,
  handleInputChange,
  handleInfepToggle,
  handleBecomeInfepMember,
  handleAddLicense,
  handleDeleteLicense,
  handleFileChange,
  registrationType = "tutor",
}) => {
  const [showCategoriesDropdown, setShowCategoriesDropdown] = useState(false);

  const renderTextField = (name, label, placeholder, required = true) => (
    <div className="form-group">
      <label>
        {label} {required ? "*" : ""}
      </label>
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        value={formData[name] || ""}
        onChange={handleInputChange}
        className="tutor-input-field"
        required={required}
      />
      {errors[name] && <p className="error">{errors[name]}</p>}
    </div>
  );

  const renderFileField = (name, label, accept = "image/*,application/pdf") => (
    <div className="form-group">
      <label>{label} *</label>
      <input
        type="file"
        name="id"
        accept={accept}
        onChange={(e) => handleFileChange(e, name)}
        className="tutor-input-field"
      />
      {errors[name] && <p className="error">{errors[name]}</p>}
      <p className="note">
        Upload{" "}
        {name === "accreditationDoc"
          ? "accreditation document"
          : "CAC document"}{" "}
        (PDF or image, max 5MB)
      </p>
    </div>
  );

  const renderAcademyFields = () => (
    <>
      {renderTextField(
        "registrationNumber",
        "Registration Number / Accreditation ID",
        "Enter registration or accreditation ID",
      )}
      {renderFileField(
        "accreditationDoc",
        "Registration/Accreditation Document Upload",
      )}
      {/* {renderTextField("cacNumber", "CAC Number", "Enter CAC number")}
      {renderFileField("cacDocument", "CAC Document Upload")} */}
    </>
  );

  const renderTutorFields = () => (
    <>
      <div className="form-title license-section">
        <h2>Add Professional License and Certification</h2>
        <p className="subtitle">
          Upgrade your profile by providing your professional license and
          certification information
        </p>
      </div>
      {renderTextField(
        "licenseName",
        "Name",
        "e.g., PMP Certification, Cisco CCNA",
      )}
      {renderTextField(
        "issuingOrganization",
        "Issuing Organization",
        "e.g., Project Management Institute, Cisco",
      )}
      <div className="form-group">
        <label>Issuing Date *</label>
        <input
          type="date"
          name="licenseIssuingDate"
          value={formData.licenseIssuingDate || ""}
          onChange={handleInputChange}
          className="tutor-input-field"
        />
        {/* {errors.licenseIssuingDate && <p className="error">{errors.licenseIssuingDate}</p>} */}
      </div>
      {renderTextField(
        "licenseCredentialId",
        "Credential ID",
        "Enter credential ID",
      )}
      <div className="form-group add-license-section">
        <label>Add License & Certification</label>
        <div className="recommendation-text">
          <p>
            We recommend adding more than one license & certification. They'll
            also appear in your profile section.
          </p>
        </div>
        <button
          type="button"
          onClick={handleAddLicense}
          className="add-school-btn"
          disabled={
            !formData.licenseName ||
            !formData.issuingOrganization ||
            !formData.licenseIssuingDate ||
            !formData.licenseCredentialId
          }
        >
          + Add License & Certification
        </button>
      </div>
      {formData.additionalLicenses?.length > 0 && (
        <div className="added-licenses">
          <h3>Added Licenses:</h3>
          {formData.additionalLicenses.map((license) => (
            <div key={license.id} className="license-item">
              <span>
                {license.name} - {license.organization} (ID:{" "}
                {license.credentialId})
              </span>
              <button
                type="button"
                onClick={() => handleDeleteLicense(license.id)}
                className="delete-license-btn"
                title="Delete license"
              >
                <FaTrash />
              </button>
            </div>
          ))}
        </div>
      )}
    </>
  );

  return (
    <>
      <div className="form-title">
        <h2>
          {registrationType === "academy"
            ? "Add your Training Center Credentials(Optional)"
            : ""}
        </h2>
        <p className="subtitle">
          {registrationType === "academy"
            ? "Provide your training center document and credentials"
            : ""}
        </p>
      </div>

      {/* <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            name="isInfepRegistered"
            checked={formData.isInfepRegistered}
            onChange={handleInfepToggle}
            className="infep-checkbox"
          />
          Are you INFEP registered?
        </label>
      </div>

      <div className="form-group infep-section">
        <div className="recommendation-text">
          <p>
            Being INFEP registered gives you 50% off our premium plan. You can
            become a registered INFEP member by clicking the button below.
          </p>
        </div>
        <button
          type="button"
          onClick={handleBecomeInfepMember}
          className="add-school-btn"
        >
          + Become a Registered INFEP Member
        </button>
      </div> */}

      {/* {formData.isInfepRegistered && (
        <>
          <div className="form-group">
            <label>Credential ID *</label>
            <input
              type="text"
              name="credentialId"
              placeholder="Enter your INFEP credential ID"
              value={formData.credentialId || ""}
              onChange={handleInputChange}
              className="tutor-input-field"
            />
            {errors.credentialId && <p className="error">{errors.credentialId}</p>}
          </div>
          <div className="form-group">
            <label>Issuing Date *</label>
            <input
              type="date"
              name="issuingDate"
              value={formData.issuingDate || ""}
              onChange={handleInputChange}
              className="tutor-input-field"
            />
            {errors.issuingDate && <p className="error">{errors.issuingDate}</p>}
          </div>
        </>
      )} */}

      {registrationType === "academy"
        ? renderAcademyFields()
        : renderTutorFields()}
      {/* Program Type */}
      <h2>Add courses and Program Type.</h2>
      <p className="subtitle">
        Add courses you specialize in and willing to teach students.
      </p>

      <div className="form-group">
        <label className="form-label required">Program Type *</label>
        <select
          name="programType"
          value={formData.programType || ""}
          onChange={handleInputChange}
          className="tutor-input-field"
        >
          <option value="">Select program type you want to offer</option>
          <option value="physical">Physical</option>
          <option value="online">Online</option>
          <option value="hybrid">Hybrid</option>
        </select>
        {errors.programType && (
          <p className="error-message">{errors.programType}</p>
        )}
      </div>

      {/* Selected Program Type Tags – this creates vertical spacing below */}
      {formData.programType && (
        <div className="selected-tags-container program-type-tags">
          <span className="selected-tag program-type-tag">
            {formData.programType.charAt(0).toUpperCase() +
              formData.programType.slice(1)}
            <button
              type="button"
              className="tag-remove-btn"
              onClick={() =>
                setFormData((prev) => ({ ...prev, programType: "" }))
              }
            >
              ×
            </button>
          </span>
        </div>
      )}

      {/* Course Category */}
      <div className="form-group">
        <label className="form-label required">Course Category *</label>

        <select
          name="mainProgram"
          value={formData.mainProgram || ""}
          onChange={(e) => {
            const val = e.target.value;
            setFormData((prev) => ({
              ...prev,
              mainProgram: val,
              selectedCourses: [], // reset courses when category changes
            }));
            setShowCategoriesDropdown(false);
          }}
          className="tutor-input-field"
        >
          <option value="">Select course category</option>
          {PROGRAM_CATEGORIES.map((group) => (
            <option key={group.group} value={group.group}>
              {group.group}
            </option>
          ))}
        </select>

        {errors.mainProgram && (
          <p className="error-message">{errors.mainProgram}</p>
        )}
      </div>

      {/* Selected Course Category Tag */}
      {formData.mainProgram && (
        <div className="selected-tags-container">
          <span className="selected-tag">
            {formData.mainProgram}
            <button
              type="button"
              className="tag-remove-btn"
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  mainProgram: "",
                  selectedCourses: [],
                }))
              }
            >
              ×
            </button>
          </span>
        </div>
      )}

      {/* Courses – custom dropdown */}
      {formData.mainProgram && (
        <div className="form-group compact-tags-group">
          <label className="form-label required">Courses *</label>

          <div className="custom-dropdown-container dropdown-wrapper">
            <div
              className="dropdown-trigger tutor-input-field"
              onClick={() => setShowCategoriesDropdown((p) => !p)}
            >
              <span>
                {formData.selectedCourses.length
                  ? `${formData.selectedCourses.length} selected`
                  : "Select course"}
              </span>
              <span className="dropdown-arrow">
                {showCategoriesDropdown ? "▲" : "▼"}
              </span>
            </div>

            {showCategoriesDropdown && (
              <div className="custom-dropdown-panel">
                {PROGRAM_CATEGORIES.find(
                  (g) => g.group === formData.mainProgram,
                )?.items.map((cat) => (
                  <label key={cat} className="dropdown-item">
                    {/* <input
                            type="checkbox"
                            className="category-checkbox"
                            checked={formData.selectedCourses.includes(cat)}
                            onChange={() => {
                              setFormData((prev) => {
                                const exists = prev.selectedCourses.includes(cat);
                                let updated = exists
                                  ? prev.selectedCourses.filter((c) => c !== cat)
                                  : prev.selectedCourses.length < 5
                                    ? [...prev.selectedCourses, cat]
                                    : prev.selectedCourses;
      
                                return { ...prev, selectedCourses: updated };
                              });
                            }}
                          /> */}
                    <input
                      type="checkbox"
                      className="category-checkbox"
                      checked={formData.selectedCourses.includes(cat)}
                      disabled={
                        formData.selectedCourses.length >= 5 &&
                        !formData.selectedCourses.includes(cat)
                      }
                      onChange={() => {
                        setFormData((prev) => {
                          const exists = prev.selectedCourses.includes(cat);

                          let updated = exists
                            ? prev.selectedCourses.filter((c) => c !== cat)
                            : prev.selectedCourses.length < 5
                              ? [...prev.selectedCourses, cat]
                              : prev.selectedCourses;

                          return { ...prev, selectedCourses: updated };
                        });
                      }}
                    />

                    <span>{cat}</span>
                  </label>
                ))}
              </div>
            )}
            {formData.selectedCourses.length >= 5 && (
              <p className="course-limit-hint">Max 5 courses allowed</p>
            )}
          </div>

          {/* ✅ THIS WILL NOW SHOW */}
          {formData.selectedCourses.length > 0 && (
            <div className="selected-tags-container compact">
              {formData.selectedCourses.map((course) => (
                <span key={course} className="selected-tag compact-tag">
                  {course}
                  <button
                    type="button"
                    className="tag-remove-btn"
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        selectedCourses: prev.selectedCourses.filter(
                          (c) => c !== course,
                        ),
                      }))
                    }
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Pricing Rate – Per ... at the beginning */}
      <div className="form-group">
        <label className="form-label required">Pricing Rate *</label>
        <div className="rate-input-group">
          <select
            name="ratePeriod"
            value={formData.ratePeriod || "hour"}
            onChange={handleInputChange}
            className="rate-period-select"
          >
            <option value="hour">Per hour</option>
            <option value="day">Per day</option>
            <option value="week">Per week</option>
            <option value="month">Per month</option>
          </select>
          <input
            type="number"
            name="hourlyRate"
            placeholder="0.00"
            value={formData.hourlyRate || ""}
            onChange={handleInputChange}
            min="0"
            className="tutor-input-field rate-amount-input"
          />
        </div>
        {errors.hourlyRate && (
          <p className="error-message">{errors.hourlyRate}</p>
        )}
      </div>
    </>
  );
};

export default StepCredentials;
